/**
 * The share mark: a filled arrow with a swoosh tail (Sam, 2026-10-31, after Partiful's). Every Share button uses it, in
 * place of lucide's box-and-arrow and the external-link square. Same props as a lucide icon: size, className, the rest.
 */
export default function ShareIcon({ size = 24, className = '', ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinejoin="round"
      className={className}
      {...props}
    >
      <path d="M14 3.5 21.5 10 14 16.5V13c-5.2 0-8.8 1.8-11.5 6.5C3.2 13.4 6.6 8.3 14 7.4Z" />
    </svg>
  );
}
